// ChatBot.styles.js

export const headerContainerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: { xs: "16px", md: "24px 24px", lg: "24px 24px" },
};

export const headerTitleStyle = {
  fontSize: { xs: "14px", md: "16px", lg: "18px" },
  fontWeight: 400,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

export const headerIconsContainerStyle = {
  display: "flex",
  gap: { xs: "8px", lg: "12px" },
  alignItems: "center",
};

export const GradientText = {
  display: "inline-block",
  background:
    "linear-gradient(270.52deg, #FFEC9A -0.75%, #00B2FF 14.53%, #1F36C7 101.09%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
  color: "transparent",
  fontSize: { xs: "28px", md: "32px", lg: "40px" },
  fontWeight: 500,
  position: "relative",
  marginBottom: { xs: "16px", lg: "24px" },
};

export const BoxShade = {
  // background:
  //     "linear-gradient(180deg, rgba(219, 225, 230, 0.2) 0%, rgba(166, 181, 191, 0.2) 100%)",
  borderRadius: "32px",
  padding: "5px",
};

export const greenShade = (step) => ({
  position: "relative",
  padding: "5px",
  borderRadius: "32px",
  overflow: "hidden",

  "&:before": {
    opacity: step >= 3 ? 1 : 0,
    transition: "opacity 0.6s ease",
    background:
      "linear-gradient(145.45deg, #FFEC9A -130.81%, #CCF0EB 50.06%, #00B2FF 188.34%)",
    width: "100%",
    height: "100%",
    content: '""',
    borderRadius: "32px",
    position: "absolute",
    top: 0,
    left: 0,
    transform: "rotate(180deg)",
    pointerEvents: "none",
  },

  "&:after": {
    opacity: step >= 3 ? 1 : 0,
    transition: "opacity 0.6s ease 0.2s",
    background:
      "linear-gradient(0deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.8) 50%, rgba(255, 255, 255, 0.6) 100%)",
    width: "100%",
    height: "100%",
    content: '""',
    borderRadius: "32px",
    position: "absolute",
    top: 0,
    left: 0,
    transform: "rotate(180deg)",
    pointerEvents: "none",
  },
});

export const smallIconStyle = {
  height: { xs: "16px", md: "24px", lg: "32px" },
  width: { xs: "16px", md: "24px", lg: "32px" },
  borderRadius: "50%",
  transition: "all 0.3s",
  cursor: "pointer",
  "&:hover": {
    background: "#C2E0FF",
  },
};
export const smallIconStyles = {
  height: { xs: "16px", md: "24px", lg: "32px" },
  width: { xs: "16px", md: "24px", lg: "32px" },
  background: "#f8fbfc",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  transition: "background 0.2s ease",
  border: "1px solid #354ACD",
  padding: "4px",
  "&:hover": {
    background: "#C2E0FF",
  },
};
export const AskOverallStyle = {
  zIndex: 2000,
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  p: { xs: "10px", md: "12px", lg: "16px" },
  borderRadius: "20px",
  background: "#F0F7FF",
  border: "1px solid #C2E0FF",
  boxShadow: "0 2px 8px rgba(0, 102, 204, 0.15)",
  cursor: "pointer",
  userSelect: "none",
  transition: "all 0.2s ease",
  "&:hover": {
    background: "#E4EEFF",
    boxShadow: "0 3px 10px rgba(0, 102, 204, 0.2)",
  },
};
export const AskStyle = {
  fontSize: 12,
  fontWeight: 400,
  lineHeight: 1,
  background: "linear-gradient(90deg, #0066CC 0%, #4A7DE8 50%, #8A7DE8 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
  whiteSpace: "nowrap",
};
export const ExpandIconStyle = {
  height: { xs: "16px", md: "24px", lg: "32px" },
  width: { xs: "16px", md: "24px", lg: "32px" },
  border: "1px solid #0066CC",
  borderRadius: "50%",
  padding: "4px",
  "&:hover": {
    backgroundColor: "#C2E0FF",
    borderRadius: "50%",
  },
};
export const BoxStyle = {
  position: "relative",
  minHeight: { xs: 260, lg: 340 },
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  "@keyframes introFadeIn": {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  "@keyframes introTextReveal": {
    from: { opacity: 0, clipPath: "inset(0 100% 0 0)" },
    to: { opacity: 1, clipPath: "inset(0 0 0 0)" },
  },
};
export const DisplayStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
export const MenuStyles = {
  "& .MuiMenu-paper": {
    background: "linear-gradient(180deg, #C2E0FF -119.85%, #FFFFFF 100%)",
    border: "1px solid #C2E0FF",
    borderRadius: "10px",
    p: "2px",
    "& .MuiMenu-list": {
      p: 0,
      "& .MuiMenuItem-root": {
        p: "12px",
        borderBottom: "1px solid #D9E1E7",
        fontSize: "14px",
        lineHeight: "140%",
        color: "#667F93",
        borderRadius: "4px",
        "&:hover": {
          background: "#fff",
        },
        "&:last-child": {
          borderBottom: 0,
        },
        "& img": {
          mr: 1,
        },
      },
    },
  },
};

export const SwitchStyles = {
  p: { xs: "6px 12px", lg: "8px 16px" },
  borderRadius: "10px",
  cursor: "pointer",
  transition: "all 0.2s ease",

  "& .SwitchOptions": {
    fontSize: { xs: "14px", lg: "16px" },
    lineHeight: "20px",
    fontWeight: 400,
  },
};

export const tooltipProps = {
  slotProps: {
    tooltip: {
      sx: {
        backgroundColor: "#F6F7F0 !important",
        color: "#1A2025 !important",
        fontSize: { sm: "7px", md: "8px", lg: "12px" },
        p: "4px 16px !important",
        fontWeight: 400,
        borderRadius: "6px",
      },
    },
  },
};
// ── Pre-computed static styles (hoisted out of render) ──
export const QUOTED_CHIP_CONTAINER_SX = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  px: 1.5,
  py: 1,
  mb: 1,
  borderRadius: "24px",
  background: "#EAF2FF",
  border: "1px solid #C2E0FF",
  maxWidth: "100%",
};
export const QUOTED_CHIP_ICON_SX = {
  color: "#4D5F6E",
  p: 0.25,
  flexShrink: 0,
  position: "relative",
  zIndex: 1100,
};
export const QUOTED_CHIP_TEXT_SX = {
  flex: 1,
  minWidth: 0,
  fontSize: { xs: 8, md: 10, lg: 14 },
  color: "#1A2025 !important",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  position: "relative",
  zIndex: 1100,
  textAlign: "start",
};
export const QUOTED_CHIP_CLOSE_SX = {
  color: "#0066CC",
  p: 0.25,
  flexShrink: 0,
};
export const QUOTED_CHIP_CLOSE_ICON_SX = { fontSize: 16, color: "#0066CC" };

export const HOVER_LABEL_SX = {
  position: "absolute",
  right: "100%",
  fontSize: { xs: "10px", md: "12px", lg: "16px" },
  fontWeight: 400,
  color: "#0066CC",
  opacity: 0,
  visibility: "hidden",
  transition: "opacity 0.25s ease, visibility 0.25s ease",
  whiteSpace: "nowrap",
};